import React from 'react'
import { useTranslation } from 'react-i18next'

import { useColumnToggle } from '../../../../hooks/useColumnToggle'
import {
  ConfigurableTable,
  convertDeliveryForecastDespatchAdvice,
} from '../../../../utils/wrapper'
import { useAllDeliveryForecastDespatchAdvices } from '../../../delivery-forecast-despatch-advice/data'
import { useConfigContext } from '../../../ui-config'

const TOGGLEABLE_FIELDS = [
  'Payload.Item.DesAdvPosition',
  'Payload.Plant',
  'Payload.UnloadingPoint',
  'Payload.Item.BuyerProductId',
  'Payload.Item.BuyerProductDescription',
  'Payload.CurrentReleaseNumber',
  'Payload.DeliveryDate',
  'Payload.Item.ConfirmationQuantity',
  'Payload.DeliveryType',
]

const STORAGE_KEY = 'delivery-forecast-despatch-advices-visible-columns'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
  isVisible: boolean
}

export const DespatchAdvicesTable: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
  isVisible,
}) => {
  const { t } = useTranslation()

  const { data, isLoading, error } = useAllDeliveryForecastDespatchAdvices()
  const { uiConfig: config } = useConfigContext()

  const tableConfig = config.deliveryForecasts.despatchAdvice.table
  const { effectiveTableConfig, navigationColumnHeader } = useColumnToggle(
    tableConfig,
    TOGGLEABLE_FIELDS,
    STORAGE_KEY,
  )

  return (
    <>
      <div hidden={!isVisible && (data === undefined || data.length < 1)}>
        {config.deliveryForecasts.despatchAdvice.enabled && (
          <div className="mt-6">
            <h3>
              {t('deliveryForecasts.deliveryForecastsDespatchAdvices.title')}
            </h3>

            <ConfigurableTable
              config={effectiveTableConfig}
              data={convertDeliveryForecastDespatchAdvice(data)}
              link={'delivery-forecasts/despatch-advice'}
              globalFilterFields={['Payload.OrderId']}
              globalFilterValue={globalFilterValue}
              setGlobalFilterValue={setGlobalFilterValue}
              isLoading={isLoading}
              stateKey="table-delivery-forecast-despatch-advices"
              navigationColumnHeader={navigationColumnHeader}
            />
          </div>
        )}
      </div>
    </>
  )
}
